module.exports = __webpack_public_path__ + "static/white_dragon_on_a_cliff-630bcbfc2553cc3712f1e8a1ebf54210.png";